import { IRest } from './rest.interface';
import { StudyStats } from 'src/models';

export class Goal implements IRest {
    className = 'Metas de Estudo';

    id!: number;
    date!: Date;
    duration!: number;
    durationHours!: number; //Uso Interno
    durationMinutes!: number; //Uso Interno
    durationTotal!: string; //Uso Interno
    questions!: number;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            date: this.date.toISOString(),
            duration: ((this.durationHours * 3600) + (this.durationMinutes * 60)),
            questions: this.questions
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.date = data['date'] ? new Date(data['date']) : new Date(2000, 0);
            this.duration = (data['duration'] || 0) / 3600;
            this.durationHours = Math.floor((data['duration'] || 0) / 3600);
            this.durationMinutes = Math.floor(((data['duration'] || 0) % 3600) / 60);
            this.durationTotal = `${this.durationHours}h${this.durationMinutes.toString().padStart(2, '0')}min`;
            this.questions = data['questions'] || 0;
        }
        return this;
    }

}

export class GoalLatest implements IRest {
    className = 'Métricas das Metas de Estudo';

    startOfWeek!: Date;
    goal!: Goal;
    studyStats!: Array<StudyStats>;

    hoursPercentage!: string; //Uso Interno
    questionsPercentage!: string; //Uso Interno

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            startOfWeek: this.startOfWeek.toISOString(),
            goal: this.goal.Serialize(),
            studyStats: this.studyStats.map(ss => ss.Serialize()),
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.startOfWeek = data['startOfWeek'] ? new Date(data['startOfWeek']) : new Date(2000, 0);
            this.goal = new Goal(data['goal'] || {});
            this.studyStats = (data['studyStats'] || []).map((ss: any) => new StudyStats(ss));

            if (this.studyStats.length) {
                let hours = (this.studyStats[0].duration / ((this.goal.duration || 1) * 3600)) * 100;
                if (hours > 100) hours = 100;
                this.hoursPercentage = `${hours.toFixed(1).replace('.0', '')}%`;

                let questions = ((this.studyStats[0].questionsHit + this.studyStats[0].questionsMiss) / (this.goal.questions || 1)) * 100;
                if (questions > 100) questions = 100;
                this.questionsPercentage = `${questions.toFixed(1).replace('.0', '')}%`;
            }
        }
        return this;
    }

}